import { useEffect, useState } from "react";
import { GET_ENTERPRISES_TAX_DEFENSE } from "../../../../api/apiEmpresas";
import CardHeader from "../../../atoms/CardHeader";
import Breadcrumb from "../../../molecules/Breadcrumb";
import CardTables from "../../../atoms/CardTables";
import DFEmpresaList from "../../../organisms/DF/DFEmpresaList";

const EmpresasTemplate = ({ id }) => {
    const [empresas, setEmpresas] = useState([]);
    const [loading, setLoading] = useState(false);

    const getEmpresas = async () => {
        try {
            setLoading(true);
            const data = await GET_ENTERPRISES_TAX_DEFENSE();
            setEmpresas(data);
        } catch (error) {
            console.error("Error fetching empresas:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        getEmpresas();
    }, []);

    return(
        <div className="space-y-2">
            <CardHeader>
                <Breadcrumb
                    items={[
                        { label: "Inicio", to: "/dashboard" },
                        { label: "Empresas clientes de Defensa Fiscal", to: null },
                    ]}
                />
            </CardHeader>
            <CardTables>
                <DFEmpresaList data={empresas} loading={loading} refetch={getEmpresas} />
            </CardTables>
        </div>
    )
};

export default EmpresasTemplate;